"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationJsonToExchangeConfigurationV1Transformer = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const ExchangeConfigurationV1_1 = require("./ExchangeConfigurationV1");
class ConfigurationJsonToExchangeConfigurationV1Transformer {
    static transform({ appName, configurationJson, removedArticles, }) {
        const domainVersion = configurationJson.DomainVersion;
        if (!domainVersion) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transform() DomainVersion undefined`);
        }
        const managedConfigurationType = configurationJson.ManagedConfigurationType;
        if (!managedConfigurationType) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transform() ManagedConfigurationType undefined`);
        }
        const igusGUId = configurationJson.IgusGUId;
        if (!igusGUId) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transform() IgusGUId undefined`);
        }
        const exchangeConfiguration = {
            // required
            ExchangeConfigurationVersion: 'v1',
            DomainVersion: domainVersion,
            ManagedConfigurationType: managedConfigurationType,
            IgusGUId: igusGUId,
            PdfRefs: [],
            FileRefs: [],
            // optional
            AppName: appName,
            ConfigurationStartedWith: configurationJson.ConfigurationStartedWith,
            QuoteCount: configurationJson.QuoteCount,
            LeitungenLoseBeilegen: configurationJson.LeitungenLoseBeilegen,
            IsManualMode: configurationJson.IsManualMode,
            IaArrangement: configurationJson.IaArrangement,
            IAZeichnungsnummer: configurationJson.IAZeichnungsnummer,
            CustomKonfektionierungPrice: this.cloneIfDefined(configurationJson.CustomKonfektionierungPrice),
            // articles
            AEs: (configurationJson.AEs || []).map((a) => this.transformArticle(a)),
            Espool: configurationJson.Espool ? this.transformArticle(configurationJson.Espool) : configurationJson.Espool,
            Fuehrungsrinnen: (configurationJson.Fuehrungsrinnen || []).map((a) => this.transformArticle(a)),
            IAs: (configurationJson.IAs || []).map((a) => this.transformIa(a)),
            Kette: this.transformKette(configurationJson.Kette),
            Konfektionierungen: (configurationJson.Konfektionierungen || []).map((a) => this.transformArticle(a)),
            Leitungen: (configurationJson.Leitungen || []).map((a) => this.transformLeitung(a)),
            MontageSets: (configurationJson.MontageSets || []).map((a) => this.transformArticle(a)),
            MontBes: (configurationJson.MontBes || []).map((a) => this.transformArticle(a)),
            Verpackungen: (configurationJson.Verpackungen || []).map((a) => this.transformArticle(a)),
            Zugentlastungen: (configurationJson.Zugentlastungen || []).map((a) => this.transformArticle(a)),
            RemovedArticles: echain_shared_articles_1.ArticlesDictUtils.create(),
        };
        // transform `removedArticles` to simple `ExchangeArticleV1`
        echain_product_models_1.allArticleTypes.forEach((articleType) => removedArticles[articleType].forEach((a) => {
            exchangeConfiguration.RemovedArticles[articleType].push(this.transformArticle(a));
        }));
        return exchangeConfiguration;
    }
    static transformKette(a) {
        if (!a)
            return undefined;
        const exchangeArticle = this.transformArticle(a);
        // keep this array in sync with the picked props of 'ExchangeKetteV1InAdditionToArticleV1' !
        const keysToClone = ['KetteSerieType', 'ArticleSpecs'];
        keysToClone.forEach((k) => {
            exchangeArticle[k] = this.cloneIfDefined(a[k]);
        });
        if (!(0, ExchangeConfigurationV1_1.isExchangeKetteV1)(exchangeArticle)) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transformKette() not ExchangeKetteV1`);
        }
        return exchangeArticle;
    }
    static transformLeitung(a) {
        const exchangeArticle = this.transformArticle(a, {
            checkArtNrGenerated: !a.IsPlaceholder,
        });
        // keep this array in sync with the picked props of 'ExchangeLeitungV1InAdditionToArticleV1' !
        const keysToClone = [
            'Aussendurchmesser',
            'Beschriftung',
            'BeschriftungText',
            'BiegeradiusMin',
            'Categories',
            'GewichtKgProKm',
            'IAIndex',
            'IsPlaceholder',
            'Kupferzahl',
            'Leitungsaufbau',
            'LocalTransform',
            'Stecker1',
            'Stecker2',
            'SteckerFp',
            'SteckerMn',
            'MainCategory',
            'UeberstandFestpunkt',
            'UeberstandMitnehmer',
        ];
        keysToClone.forEach((k) => {
            // @ts-ignore
            exchangeArticle[k] = this.cloneIfDefined(a[k]);
        });
        exchangeArticle.IsPlacedInKette = (0, echain_shared_articles_oo_1.A)(a).isPlacedInKette();
        if (!(0, ExchangeConfigurationV1_1.isExchangeLeitungV1)(exchangeArticle)) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transformLeitung() not ExchangeLeitungV1`);
        }
        return exchangeArticle;
    }
    static transformIa(a) {
        const exchangeArticle = this.transformArticle(a);
        // keep this array in sync with the picked props of 'ExchangeIaV1InAdditionToArticleV1' !
        const keysToClone = ['StartingAtNthKettenglied', 'PerNthKettenglied'];
        keysToClone.forEach((k) => {
            exchangeArticle[k] = this.cloneIfDefined(a[k]);
        });
        exchangeArticle.IaIProType = a.Artikeltyp;
        if (!(0, ExchangeConfigurationV1_1.isExchangeIaV1)(exchangeArticle)) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transformIa() not ExchangeIaV1`);
        }
        return exchangeArticle;
    }
    static transformArticle(a, { checkArtNrGenerated } = { checkArtNrGenerated: true }) {
        const articleType = a.ArticleType;
        if (!articleType) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transformArticleModel() ArticleType undefined`);
        }
        const ArtNrGenerated = a.ArtNrGenerated;
        if (checkArtNrGenerated && !ArtNrGenerated) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transformArticleModel() ArtNrGenerated undefined`);
        }
        const exchangeArticle = {
            // required
            ArticleType: articleType,
            ArtNrGenerated,
            // optional
            Id: a.Id,
            ArtNr: a.ArtNr,
            ArticleSpecs: a.ArticleSpecs,
            Bezeichnung: a.Bezeichnung,
        };
        if (!(0, ExchangeConfigurationV1_1.isExchangeArticleV1)(exchangeArticle, { checkArtNrGenerated })) {
            throw new Error(`${ConfigurationJsonToExchangeConfigurationV1Transformer.name}.transformArticle() not ExchangeArticle1`);
        }
        return exchangeArticle;
    }
    static cloneIfDefined(whatever) {
        return whatever ? (0, echain_shared_ts_utils_1.clonePrimitive)(whatever) : whatever;
    }
}
exports.ConfigurationJsonToExchangeConfigurationV1Transformer = ConfigurationJsonToExchangeConfigurationV1Transformer;
//# sourceMappingURL=ConfigurationJsonToExchangeConfigurationV1Transformer.js.map